export default {
  tags: {
    preferred: 'Preferat',
  },
};
